import zod from 'zod';

const codeSchema = zod
  .object({
    1: zod.number().min(0).max(9),
    2: zod.number().min(0).max(9),
    3: zod.number().min(0).max(9),
    4: zod.number().min(0).max(9),
  })
  .required();

export { codeSchema };
